<script setup lang="ts">
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import TheTermsAndConditionsModal from '@components/ui/prepay&terms-and-conditions/TheTermsAndConditionsModal.vue';

const { open } = usePopOver({
    component: TheTermsAndConditionsModal,
});
</script>

<template>
    <div class="terms-conditions">
        <mr-icon
            :icon="faCircleInfo"
            size="x-small"
            color="var(--cool-gray-700)"
        />
        <mr-typography size="x-small" weight="500" color="var(--gray-900)">
            با انتخاب گزینه‌ی تأیید و پرداخت
            <mr-typography
                type="span"
                size="x-small"
                weight="500"
                color="var(--blue-400)"
                class="terms-conditions-link"
                @click="open"
            >
                قوانین سفر، جریمه و استرداد
            </mr-typography>
            را مطالعه کرده‌ام و با آن موافقم.
        </mr-typography>
    </div>
</template>

<style scoped lang="scss">
.terms-conditions {
    display: flex;
    align-items: center;
    gap: 4px;
    .terms-conditions-link {
        cursor: pointer;
    }
}
</style>
